import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ButtonHeading, CommonInput, CustomPagination, CustomSelect, InvoiceStepperComponent } from 'components'
import { AddEditLrModal, ConfirmModalFor, LrDetailModal } from 'modals';
import { UserContext } from 'context';
import { getInvoiceBillRaiseSummaryData, getListDataForSelectClaims } from '_services/invoiceBillRaiseServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { FaRegTrashCan } from 'react-icons/fa6';
import { utils } from 'helper';

const ClaimSelected = () => {

  const navigate = useNavigate()
  const shouldReloadRef = useRef(false);
  const { states, invoiceBillRaiseData, setInvoiceBillRaiseData } = useContext(UserContext)
  const [stateStatus, setStateStatus] = useState({});
  const [leaveShowConfirm, setLeaveShowConfirm] = useState(false);

  const [checkedBillRaiseLr, setCheckedBillRaiseLr] = useState(invoiceBillRaiseData?.select_claim_ids)

  const [claimList, setClaimList] = useState([])
  const [loading, setLoading] = useState(false);

  const [showAddLR, setShowAddLR] = useState(false);
  const [showLrDetail, setShowLrDetail] = useState(false)

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!shouldReloadRef.current) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const claimListData = async (data = []) => {
    setLoading(true);
    try {
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
        // billraise_type: invoiceBillRaiseData?.billraise_type?.value,
        consignor_id: invoiceBillRaiseData?.consignor_id?.value ? invoiceBillRaiseData?.consignor_id?.value : '',
        select_claim_ids: data?.length > 0 ? data : invoiceBillRaiseData?.select_claim_ids,
      }
      const res = await getListDataForSelectClaims(object);
      if (res?.responseCode == 200) {
        setLoading(false);
        setClaimList(res?.data?.list);
        setTotalItems(res?.data?.total_record);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    claimListData();
  }, [filter])

  const discardHandlerFunction = (e) => {
    e.preventDefault();
    setLeaveShowConfirm(true);
  }

  const submitLeaveModalProps = () => {
    navigate('/invoicing')
  }

  let leaveModalProps = {
    show: leaveShowConfirm,
    closeModal: (e) => setLeaveShowConfirm(!leaveShowConfirm),
    title: "Leave This Page",
    submitTitle: "Confirm",
    onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",
  };

  const callNextSteperCall = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        consignor_id: invoiceBillRaiseData?.consignor_id?.value,
        gst_percentage: invoiceBillRaiseData?.gst_percentage?.value ? invoiceBillRaiseData?.gst_percentage?.value : '',
        select_claim_ids: invoiceBillRaiseData?.select_claim_ids,
        billraise_type: invoiceBillRaiseData?.billraise_type?.value ? invoiceBillRaiseData?.billraise_type?.value : '',
      }
      const res = await getInvoiceBillRaiseSummaryData(object);
      if (res?.responseCode === 200) {
        setInvoiceBillRaiseData((s) => ({ ...s, invoice_summary: res?.data?.invoice_summary }));
        navigate('/invoicing/summary', { state: res?.data });
      }
    } catch (error) {
      // throw error;
    }
  }

  const handleSelectLrSteper = async (e) => {
    e.preventDefault();
    callNextSteperCall();
  }

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const handleDeleteListCheckbox = async (id) => {
    let data = [...invoiceBillRaiseData?.select_claim_ids];
    let values = data?.filter((item) => item !== id);
    setInvoiceBillRaiseData((s) => ({ ...s, select_claim_ids: values }));
    claimListData(values);
  };

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  }

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  }

  return (
    <>
      <InvoiceStepperComponent
        headingName="Selected Claims"
        greenTickNumber={3}
        isClaim={true}
      />

      <div className='_blRaise_fitsTop'>
        <div className="_fleX_inds _blRaise_fits">
          <div className="_divForth">
            <CommonInput
              type="text"
              placeholder="Party Name"
              label="Party Name"
              name='name'
              value={invoiceBillRaiseData?.consignor_id?.label ? invoiceBillRaiseData?.consignor_id?.label : ''}
              disabled={true}
            />
          </div>

          <div className="_divForth">
            <CommonInput
              type="text"
              placeholder={invoiceBillRaiseData?.receiving_state?.label ? "Receiving State" : "State"}
              label={invoiceBillRaiseData?.receiving_state?.label ? "Receiving State *" : "State"}
              name='name'
              value={invoiceBillRaiseData?.receiving_state?.label ? invoiceBillRaiseData?.receiving_state?.label : invoiceBillRaiseData?.state?.label}
              disabled={true}
            />
          </div>
        </div>
      </div>

      <div className='_tabWith_invoiceTab __selectedClaims'>
        <div>
          <div className="_tab_htLane">
            <div className="anv_fr_detailHead">
              <table className="_trpTable_xd">
                <thead className="table_head_style">
                  <tr>
                    <th></th>
                    <th>LR Number</th>
                    <th>Party Name</th>
                    <th>Voucher No.</th>
                    <th>From Station</th>
                    <th>To Station</th>
                    <th>Claim Name</th>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? <tr>
                    <td><span className="_tblText"> Loading... </span></td>
                  </tr> : (claimList?.length > 0 ? claimList?.map((rowData, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>
                        {invoiceBillRaiseData?.select_claim_ids?.length === 1 ? <></> : <span
                          className='_del_lrM_btn _avPointer'
                          onClick={(e) => handleDeleteListCheckbox(rowData._id)}
                        >
                          <FaRegTrashCan className='del_lrCion' />
                          <span>
                            Delete
                          </span>
                        </span>}
                      </td>
                      <td>
                        <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction({ ...rowData?.lr, consignor_id: rowData?.vendor_detail?._id })}> <a className='_avPointer'> {rowData?.lr?.lr_number ? rowData?.lr?.lr_number : '-'} </a> </div>
                      </td>
                      <td>
                        <div className='_tblText _lrNums'> <Link className='_avPointer' to={`/account/consignor/details/${rowData?.vendor_detail?._id}`}> {rowData?.vendor_detail?.name ? rowData?.vendor_detail?.name : '-'} </Link> </div>
                      </td>
                      <td>{rowData?.voucher_no ? rowData?.voucher_no : '-'}</td>
                      <td>{rowData?.lr?.from_location ? rowData?.lr?.from_location : '-'}</td>
                      <td>{rowData?.lr?.to_location ? rowData?.lr?.to_location : '-'}</td>
                      <td>
                        {rowData?.categories?.length > 0 ? rowData?.categories?.map((el) => {
                          return (
                            <>{el?.category?.name}</>
                          )
                        }) : '-'}
                      </td>
                      <td>{rowData?.description ? utils.spliceString(rowData?.description, 0, 13) : '-'} </td>
                      <td>{rowData?.total_amount ? (rowData?.total_amount).toFixed(2) : '-'}</td>
                    </tr>
                  )) :
                    <tr>
                      <td><span className="_tblText">No data</span></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {claimList?.length > 0 && <div className='paginationFt_avt mb-5'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}
      </div>

      <div className='_billRaiseFooter'>
        <div className='prevDiscard_bx'>
          <button className='_previousBtn' onClick={(e) => navigate('/invoicing/select_claims')}><span>Previous</span></button>
          <button className='_discardBtn' onClick={(e) => discardHandlerFunction(e)}><span>Discard</span></button>
        </div>

        <div>
          <button
            className='_stepSuccessBtn'
            disabled={checkedBillRaiseLr?.length === 0}
            onClick={(e) => handleSelectLrSteper(e)}
          >
            Next
          </button>
        </div>
      </div>

      {leaveShowConfirm && (
        <ConfirmModalFor {...leaveModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want leave this Page ?</p>
          </>
        </ConfirmModalFor>
      )}

      <div
        className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showLrDetail ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
      >
        {showLrDetail
          && (
            <LrDetailModal
              isOpen={showLrDetail}
              onClose={(e) => setShowLrDetail(false)}
              nextModal={(e) => handleNextModal(e)}
            />
          )
        }
      </div>
      <div className={showLrDetail ? 'offBack_drop' : ''}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showAddLR ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
      >
        {showAddLR
          && (
            <AddEditLrModal isOpen={showAddLR} onClose={() => setShowAddLR(false)} />
          )
        }
      </div>
      <div className={showAddLR ? 'offBack_drop' : ''}></div>
    </>
  )
}

export default ClaimSelected